const checkThumbnail = (width) => {
  if (width === 120) {
    return false;
  } else {
    return true;
  }
};

export const validateYoutubeId = (id) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = 'http://img.youtube.com/vi/' + id + '/mqdefault.jpg';

    img.onload = function () {
      resolve(checkThumbnail(this.width));
    };

    img.onerror = reject;
  });
};
